import { TFunction } from "i18next";

export function formatDuration(totalSeconds: number, i18n: TFunction) {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = Math.floor(totalSeconds % 60);

  if (totalSeconds < 60) {
    return `${seconds} ${i18n(`second${seconds === 1 ? "" : "s"}`)}`;
  }

  if (totalSeconds < 3600) {
    return `${minutes} ${i18n(`minute${minutes === 1 ? "" : "s"}`)}, ${seconds} ${i18n(
      `second${seconds === 1 ? "" : "s"}`
    )}`;
  }

  return `${hours} ${i18n(`hour${hours === 1 ? "" : "s"}`)}, ${minutes} ${i18n(
    `minute${minutes === 1 ? "" : "s"}`
  )}, ${seconds} ${i18n(`second${seconds === 1 ? "" : "s"}`)}`;
}

export function getMetricValue(metricType: string, sessionResults: any, isTarget: boolean = false): number {
  if (!sessionResults?.scores) return 0;

  const scoreData = sessionResults.scores[metricType];
  return isTarget ? scoreData?.target_score || 0 : scoreData?.final_score || 0;
}

export function calculatePercentageChange(current: number, previous: number): number {
  if (previous === 0) return 0;
  return Number((((current - previous) / previous) * 100).toFixed(1));
}

export function formatScore(score: number, decimals: number = 1): string {
  return Number(score).toFixed(decimals);
}

export function getSessionDuration(sessionResults: any): number {
  if (!sessionResults?.play_item_results) return 0;

  return sessionResults.play_item_results.reduce(
    (total: number, item: any) => total + (item.gameplay_duration || 0),
    0
  );
}

export function getSessionDate(sessionResults: any): Date | null {
  if (!sessionResults?.play_items?.[0]?.updated_at) return null;
  return new Date(sessionResults.play_items[0].updated_at);
}

export function buildChartData(sessionResults: any, metricType: string) {
  if (!sessionResults?.play_item_results) return [];

  return sessionResults.play_item_results.map((item: any, index: number) => ({
    name: `Set ${index + 1}`,
    score: item.scores?.[metricType]?.final_score || 0,
    target: sessionResults.score_goals?.[metricType]?.target_score || 0,
  }));
}

export function getSessionPoints(sessionResults: any): number {
  if (!sessionResults?.rating_config) return 0;

  return sessionResults.completed && !sessionResults.failed
    ? sessionResults.rating_config.success_reward
    : -sessionResults.rating_config.failure_penality;
}

export function validateSessionData(sessionResults: any): boolean {
  return !!(
    sessionResults &&
    sessionResults.session_score &&
    sessionResults.play_item_results &&
    sessionResults.play_items &&
    sessionResults.scores
  );
}
